import dayjs from 'dayjs';
import { addLocale, locale } from 'primereact/api';
import i18n from '../i18n-locales/i18n';

import 'dayjs/locale/ja'; // Japanese
import 'dayjs/locale/en'; // English

const setDayjsLocale = (lng: string) => {
  dayjs.locale(lng);
};

const applyPrimereactLocale = (lng: string) => {
  const bundle = i18n.getResourceBundle(lng, 'primereact');
  if (bundle) {
    addLocale(lng, bundle);
    locale(lng);
  }
};

// Apply locale once i18n has finished loading all namespaces
i18n.on('initialized', () => {
  const lng = i18n.language ?? 'ja';
  setDayjsLocale(lng);
  applyPrimereactLocale(lng);
});

// Update dayjs and PrimeReact locale when i18n language changes
i18n.on('languageChanged', (lng) => {
  setDayjsLocale(lng);
  applyPrimereactLocale(lng);
});
